import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Slider from "rc-slider";
import Tooltip from "rc-tooltip";

export default connect(mapStateToProps)(class SimpleSlider extends PureComponent {
    static propTypes = {
        init: PropTypes.number,
        min: PropTypes.number,
        max: PropTypes.number,
        step: PropTypes.number,
        action: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            value: props.init,
        };
    }

    componentWillReceiveProps(nextProps) {
        // Handle when the slider is updated from somewhere else
        this.setState({ value: nextProps.init });
    }

    onChange(e) {
        this.setState({ value: e });
    }

    onAfterChange(e) {
        this.props.action(this.props.target, e);
    }

    render() {
        const Handle = Slider.Handle;
        const handle = (props) => {
            const { value, dragging, index, ...restProps } = props;
            return (
                <Tooltip
                    prefixCls="rc-slider-tooltip"
                    overlay={value.toLocaleString(this.props.language)}
                    visible={dragging}
                    placement="top"
                    key={index}>
                    <Handle value={value} {...restProps} />
                </Tooltip>
            );
        };

        return (
            <Slider
                onChange={this.onChange.bind(this)}
                onAfterChange={this.onAfterChange.bind(this)}
                dots={false}
                handle={handle}
                value={this.state.value}
                min={this.props.min}
                max={this.props.max}
                step={this.props.step}
            />
        );
    }
})

function mapStateToProps(state){
    return {
        language: state.reducerLanguage
    }
}



// WEBPACK FOOTER //
// ./src/components/slider.js